import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { InconsistenciesResultResponse } from './get-inconsistencies-results.types';
import { transformIntoQueryParamString } from '@old/utils/service';
import { useGlobalStore } from '@old/global-store/use-store';
//levelIds=1,2,3
export async function getInconsistenciesResult() {
  const { filtersInconsistencies, organizationId } = useGlobalStore.getState();
  const rawQuery = {
    silobagId: filtersInconsistencies.silobagId,
    silobagName: filtersInconsistencies.silobagName,
    countrysidesIds: filtersInconsistencies.countrysidesIds,
    levelIds: filtersInconsistencies.levelIds,
    ruleIds: filtersInconsistencies.ruleIds,
    solved: filtersInconsistencies.solved,
    organizationId: organizationId,
  };
  const query = transformIntoQueryParamString(rawQuery);
  const { response, data } = await BACKEND.get<InconsistenciesResultResponse>(
    ENDPOINT.INCONSISTENCIES_RESULTS,
    { query }
  );

  return {
    response,
    summary: data,
  };
}
